// We will use this map to show user-friendly error messages for contracting errors
export const SUMMARY_TAB_MAP = {
    'dealStructure.financialDetails.dealDeposit': 'Cash Down',
    'dealStructure.financialDetails.dueInAdvanceDetails.securityDeposit': 'Security Deposit',
    'dealStructure.financialDetails.paymentDetails.annualMiles': 'Annual Miles',
    'dealStructure.financialDetails.paymentDetails.daysToFirstPayment': 'Days to 1st Payment',
    'dealStructure.financialDetails.paymentDetails.excessMileageCharge': '$/Mi',
    'dealStructure.financialDetails.priceDetails.retailPrice': 'MSRP',
    'dealStructure.financialDetails.priceDetails.sellingPrice': 'Selling Price',
    'dealStructure.financialDetails.programDetails.lenderLongName': 'Lender',
    'dealStructure.financialDetails.rateDetails.sellRate.apr': 'Rate',
    'dealStructure.financialDetails.rateDetails.sellRate.moneyFactor': 'Sell Rate MF',
    'dealStructure.financialDetails.residualDetails.baseResidualDollar': 'Base Residual',
    'dealStructure.financialDetails.residualDetails.baseResidualPercent': 'Base Residual',
    'dealStructure.financialDetails.residualDetails.netResidual': 'Adj Residual',
    'dealStructure.financialDetails.residualDetails.residualNetPercent': 'Adj Residual',
    'dealStructure.vehicles.tradeInVehicles.tradeInSummary.totalAllowance': 'Trade Allowance',
    'dealStructure.vehicles.tradeInVehicles.tradeInSummary.totalPayoff': 'Payoff'
};

export const TRADEIN_TAB_MAP = {
    'dealStructure.financialDetails.feeDetails.registrationType': 'Registration Type',
    'dealStructure.vehicles.tradeInVehicles.tradeIns': 'Trade in',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradePayoffDetails.goodThroughDate': 'Payoff Due Date',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradePayoffDetails.lienHolder': 'Lienholder',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradePayoffDetails.lienHolderAccountNumber': 'Account/Loan Number',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradePayoffDetails.lienHolderAddress.addressLine1': 'Bank Address',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradePayoffDetails.lienHolderAddress.city': 'City',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradePayoffDetails.lienHolderAddress.postalCode': 'ZIP',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradePayoffDetails.lienHolderAddress.stateProvince': 'State',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradePayoffDetails.lienHolderPhoneNumber.': 'Phone',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradePayoffDetails.perDiemInterest': 'Per Diem',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradeValuation.actualCashValue': 'ACV',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradeVehicle.bodyStyle': 'Body Style',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradeVehicle.condition': 'Condition',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradeVehicle.exteriorColor': 'Exterior Color',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradeVehicle.interiorColor': 'Interior Color',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradeVehicle.make': 'Make',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradeVehicle.model': 'Model',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradeVehicle.odometer': 'Odometer',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradeVehicle.powertrain.drivetrainType': 'Drive Line',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradeVehicle.powertrain.engineDetails.description': 'Engine',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradeVehicle.powertrain.transmissionDetails.description': 'Transmission',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradeVehicle.trim': 'Trim',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradeVehicle.vin': 'Vin',
    'dealStructure.vehicles.tradeInVehicles.tradeIns[?].tradeVehicle.year': 'Year',
    'dealStructure.vehicles.tradeInVehicles.tradeInSummary.totalAllowance': 'Trade Allowance',
    'dealStructure.vehicles.tradeInVehicles.tradeInSummary.totalPayoff': 'Payoff'
};

export const FEE_TAB_MAP = {
    'dealStructure.financialDetails.feeDetails.fees': 'Fees',
    'dealStructure.financialDetails.feeDetails.fees[?].feeAmount': 'Fee Amount',
    'dealStructure.financialDetails.feeDetails.fees[?].feeCategory': 'Fee Category',
    'dealStructure.financialDetails.feeDetails.fees[?].feeDescription': 'Fee Description',
    'dealStructure.financialDetails.feeDetails.fees[?].feeName': 'Fee Name',
    'dealStructure.financialDetails.feeDetails.registrationType': 'Registration Type',
    'dealStructure.financialDetails.residualDetails.residualNetPercent': 'Adj Residual'
};

export const TAXES_TAB_MAP = {
    'dealStructure.financialDetails.taxDetails.taxes': 'taxes',
    'dealStructure.financialDetails.taxDetails.taxes[?].taxAmount': 'Tax Total',
    'dealStructure.financialDetails.taxDetails.taxes[?].taxBreakdown.city.rate': 'City Rate',
    'dealStructure.financialDetails.taxDetails.taxes[?].taxBreakdown.city.taxTotal': 'City Tax Amount',
    'dealStructure.financialDetails.taxDetails.taxes[?].taxBreakdown.county.rate': 'County Rate',
    'dealStructure.financialDetails.taxDetails.taxes[?].taxBreakdown.county.taxTotal': 'County Tax Amount',
    'dealStructure.financialDetails.taxDetails.taxes[?].taxBreakdown.other.rate': 'Local Rate',
    'dealStructure.financialDetails.taxDetails.taxes[?].taxBreakdown.other.taxTotal': 'Local Tax Amount',
    'dealStructure.financialDetails.taxDetails.taxes[?].taxBreakdown.state.rate': 'State Rate',
    'dealStructure.financialDetails.taxDetails.taxes[?].taxBreakdown.state.taxTotal': 'State Tax Amount',
    'dealStructure.financialDetails.taxDetails.taxSummary.capReductionTaxSummary.isCapReductionTaxCapitalized':
        'Cap Cost Reduction Upfront',
    'dealStructure.financialDetails.taxDetails.taxSummary.isTaxCapitalized': 'Upfront Taxes',
    'dealStructure.financialDetails.taxDetails.taxSummary.monthlyUseTaxSummary.monthlyTaxAmount':
        'Monthly Use Taxes - Monthly Amount',
    'dealStructure.financialDetails.taxDetails.taxSummary.monthlyUseTaxSummary.taxAmount': 'Monthly Use Taxes - Monthly Tax',
    'dealStructure.financialDetails.taxDetails.taxSummary.monthlyUseTaxSummary.taxRate': 'Monthly Use Taxes - Rate',
    'dealStructure.financialDetails.taxDetails.taxSummary.totalTax': 'Total Tax'
};

export const PROTECTION_TAB_MAP = {
    'dealStructure.financialDetails.productDetails.products': 'Vehicle Protection',
    'dealStructure.financialDetails.productDetails.products[?].isProductPriceCapitalized': 'Capitalized',
    'dealStructure.financialDetails.productDetails.products[?].productAddOnDetails.productAddOnSummary.totalProductAddOnCost':
        'Add-on Cost',
    'dealStructure.financialDetails.productDetails.products[?].productAddOnDetails.productAddOnSummary.totalProductAddOnPrice':
        'Add-on Price',
    'dealStructure.financialDetails.productDetails.products[?].productCategoryCode': 'Category Code',
    'dealStructure.financialDetails.productDetails.products[?].productCode': 'Product Code',
    'dealStructure.financialDetails.productDetails.products[?].productCoverageLength': 'Term Months',
    'dealStructure.financialDetails.productDetails.products[?].productCoverageMiles': 'Term Miles',
    'dealStructure.financialDetails.productDetails.products[?].productDeductible': 'Deductible',
    'dealStructure.financialDetails.productDetails.products[?].productMarkup.markupDollarAmount': 'Markup/Markdown',
    'dealStructure.financialDetails.productDetails.products[?].productMarkup.markupMethod': 'Markup Method',
    'dealStructure.financialDetails.productDetails.products[?].productMonthlyPayment': 'Payment',
    'dealStructure.financialDetails.productDetails.products[?].productName': 'Product Name',
    'dealStructure.financialDetails.productDetails.products[?].productPrice': 'Product cost',
    'dealStructure.financialDetails.productDetails.products[?].productProviderName': 'Provider',
    'dealStructure.financialDetails.productDetails.products[?].productProviderPlan': 'Plan/Coverage',
    'dealStructure.financialDetails.productDetails.products[?].profitLocation': 'Profit'
};

export const PROGRAM_N_INCENTIVES_TAB_MAP = {
    'dealStructure.financialDetails.incentiveDetails': 'Programs & Incentives',
    'dealStructure.financialDetails.incentiveDetails.incentives[?].cash': 'Amount',
    'dealStructure.financialDetails.incentiveDetails.incentives[?].conditionCategory': 'Category',
    'dealStructure.financialDetails.incentiveDetails.incentives[?].description': 'Description',
    'dealStructure.financialDetails.incentiveDetails.incentives[?].endDate': 'End Date',
    'dealStructure.financialDetails.incentiveDetails.incentives[?].incentiveId': 'Code',
    'dealStructure.financialDetails.incentiveDetails.incentives[?].incentiveType': 'Type',
    'dealStructure.financialDetails.incentiveDetails.incentives[?].isManualIncentive': 'Manual Incentive',
    'dealStructure.financialDetails.incentiveDetails.incentives[?].isStandardRebate': 'Standard?',
    'dealStructure.financialDetails.incentiveDetails.incentives[?].programId': 'Program',
    'dealStructure.financialDetails.incentiveDetails.incentives[?].programName': 'Incentive Name',
    'dealStructure.financialDetails.incentiveDetails.incentives[?].programType': 'Program Type',
    'dealStructure.financialDetails.incentiveDetails.incentives[?].startDate': 'Start Date',
    'dealStructure.financialDetails.incentiveDetails.incentiveSummary.appliedIncentiveAmount': 'Incentives Total'
};

export const LENDER_TAB_MAP = {
    'dealStructure.creditApplication.creditDecision.dealerDecisionStatus': 'Lender Decision Status',
    'dealStructure.financialDetails.programDetails.lenderLongName': 'Lender',
    'dealStructure.financialDetails.rateDetails.buyRate.apr': 'Buy Rate',
    'dealStructure.financialDetails.rateDetails.buyRate.moneyFactor': 'Buy Rate MF',
    'dealStructure.financialDetails.rateDetails.sellRate.apr': 'Rate',
    'dealStructure.financialDetails.rateDetails.sellRate.moneyFactor': 'Sell Rate MF',
    'dealStructure.participants.buyer.estimatedCreditScore': 'Tier/Rating'
};

export const ACCESSORIES_TAB_MAP = {
    'dealStructure.financialDetails.accessoryDetails.accessories': 'Accessories',
    'dealStructure.financialDetails.accessoryDetails.accessories[?].accessoryInitialCost': 'Accessory Cost Price',
    'dealStructure.financialDetails.accessoryDetails.accessories[?].accessoryInstallationPrice': 'Accessory Installation Price',
    'dealStructure.financialDetails.accessoryDetails.accessories[?].accessoryName': 'Accessory Name',
    'dealStructure.financialDetails.accessoryDetails.accessories[?].accessoryPrice': 'Accessory Sale Price',
    'dealStructure.financialDetails.accessoryDetails.accessories[?].accessoryProfitLocation': 'Accessory Profit Location',
    'dealStructure.financialDetails.accessoryDetails.accessories[?].isWeOwe': 'Accessory ownership',
    'dealStructure.financialDetails.accessoryDetails.accessorySummary.totalAccessoryAmount': 'Total Accessories'
};

export const NON_DEAL_API_ERROR_MAP = {
    'body.dt_application.applicant_data.0.applicant.Regular.phone_details': 'Applicant Phone',
    'body.dt_application.applicant_data.1.coapplicant.Regular.phone_details': 'Co-Applicant Phone',
    'deal.vehicle_cash_price': 'Vechicle Cash Price',
    non_field_errors: 'Error'
};

export const CONTRACTING_ERROR_MAP: Record<string, string> = {
    ...NON_DEAL_API_ERROR_MAP,
    ...SUMMARY_TAB_MAP,
    ...TRADEIN_TAB_MAP,
    ...FEE_TAB_MAP,
    ...TAXES_TAB_MAP,
    ...PROTECTION_TAB_MAP,
    ...PROGRAM_N_INCENTIVES_TAB_MAP,
    ...LENDER_TAB_MAP,
    ...ACCESSORIES_TAB_MAP,
    // Common Deal API Fields outside of tabs
    'dealLifecycle.approvedDate': 'Approved',
    'dealLifecycle.contractSignedDate': 'Contract Signed',
    'dealLifecycle.deliveredDate': 'Delivery Date',
    'dealLifecycle.soldDate': 'Sale Date',
    'dealLifecycle.status': 'Change Deal Status',
    'dealStructure.financialDetails.dueInAdvanceDetails.netCashDown': 'Cash Down',
    'dealStructure.financialDetails.feeDetails.feeSummary.registrationExpiresOn': 'Registration Expiration Date',
    'dealStructure.financialDetails.feeDetails.feeSummary.registrationType': 'Registration Type',
    'dealStructure.financialDetails.lienHolder.lienHolder': 'Lienholder',
    'dealStructure.financialDetails.lienHolder.lienHolderAddress.addressLine1': 'Bank Address',
    'dealStructure.financialDetails.lienHolder.lienHolderAddress.city': 'City',
    'dealStructure.financialDetails.lienHolder.lienHolderAddress.postalCode': 'ZIP',
    'dealStructure.financialDetails.lienHolder.lienHolderAddress.stateProvince': 'State',
    'dealStructure.financialDetails.lienHolder.lienHolderPhoneNumber': 'Phone',
    'dealStructure.financialDetails.paymentDetails.amountFinanced': 'Amt. Financed',
    'dealStructure.financialDetails.paymentDetails.isFirstPaymentCapitalized': 'Upfront First Month Payment',
    'dealStructure.financialDetails.paymentDetails.payment': 'Monthly Payment',
    'dealStructure.financialDetails.paymentDetails.totalInterest': 'Total Interest',
    'dealStructure.financialDetails.priceDetails.itemizedDiscounts[?].discountAmount': 'Discount Amount',
    'dealStructure.financialDetails.priceDetails.itemizedDiscounts[?].discountName': 'Discount Name',
    'dealStructure.participants.additionalContacts.emailAddress': 'Secondary Email Address',
    'dealStructure.participants.buyer.address.addressLine1': 'Street Address',
    'dealStructure.participants.buyer.address.addressLine2': 'Street Address 2',
    'dealStructure.participants.buyer.address.city': 'City',
    'dealStructure.participants.buyer.address.countyDistrict': 'County',
    'dealStructure.participants.buyer.address.stateProvince': 'State',
    'dealStructure.participants.buyer.emailAddress': 'Primary Email Address',
    'dealStructure.participants.buyer.firstName': 'Legal First Name',
    'dealStructure.participants.buyer.lastName': 'Legal Last Name',
    'dealStructure.participants.buyer.middleName': 'Legal Middle Name',
    'dealStructure.participants.buyer.phoneNumber': 'Cell Phone',
    'dealStructure.participants.buyer.postalCode': 'Postal Code',
    'dealStructure.participants.buyer.salutation': 'Title',
    'dealStructure.participants.buyer.suffix': 'Suffix',
    'dealStructure.participants.coBuyer.address.addressLine1': 'Cobuyer Street Address',
    'dealStructure.participants.coBuyer.address.addressLine2': 'Cobuyer Street Address 2',
    'dealStructure.participants.coBuyer.address.city': 'Cobuyer City',
    'dealStructure.participants.coBuyer.address.countyDistrict': 'Cobuyer County',
    'dealStructure.participants.coBuyer.address.stateProvince': 'Cobuyer State',
    'dealStructure.participants.coBuyer.emailAddress': 'Cobuyer Email Address',
    'dealStructure.participants.coBuyer.firstName': 'Cobuyer Legal First Name',
    'dealStructure.participants.coBuyer.lastName': 'Cobuyer Legal Last Name',
    'dealStructure.participants.coBuyer.middleName': 'Cobuyer Legal Middle Name',
    'dealStructure.participants.coBuyer.phoneNumber': 'Cobuyer Cell Phone',
    'dealStructure.participants.coBuyer.postalCode': 'Cobuyer Postal Code',
    'dealStructure.participants.coBuyer.salutation': 'Cobuyer Title',
    'dealStructure.participants.coBuyer.suffix': 'Cobuyer Suffix',
    'dealStructure.vehicles.sellingVehicle.odometerMileage': 'Odometer',
    'dealStructure.vehicles.sellingVehicle.priceCostDetails.invoiceAmount': 'Invoice',
    'dealStructure.vehicles.sellingVehicle.priceCostDetails.originalMsrp': 'MSRP',
    'dealStructure.vehicles.sellingVehicle.priceCostDetails.salesCost': 'Cost',
    'dealStructure.vehicles.sellingVehicle.priceCostDetails.wholesaleBookSource': 'Bookout Source',
    'dealStructure.vehicles.sellingVehicle.priceCostDetails.wholesaleValue': 'Bookout Value'
};
